const cellWithCheckMultiple = {
  update: (field, appData) => {
    const { name, params, options, title } = field;
    const {
      values,
      screenValidation: { fields },
      settings
    } = appData;
    if (options.length >= 2) {
      /* eslint-disable no-useless-escape */
      const textName = name.replace("_id", "");
      const checked = values[name] === options.find(o => o.name === "Y")?.value;
      const text = values[textName] || "";
      const textParts = checked
        ? text.split(
            params.includes("TDFieldOptionIsFamilyHistory") ? /[|\/]/ : "|"
          )
        : [];
      const fieldObject = {
        fieldName: textName,
        isValid: textParts.every(p => p),
        isRequired: false,
        errorMessage: settings.translations.field_missing.replace(
          "%field_name%",
          title
        ),
        value: text,
        title
      };
      const index = fields.findIndex(f => f.fieldName === textName);
      if (index > -1) {
        fields[index] = fieldObject;
      } else {
        fields.push(fieldObject);
      }
      return fieldObject;
    }
  }
};

export default cellWithCheckMultiple;
